import { ButtonRoundedSm, ButtonRoundedWithIcon, FileSelect } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { useState } from 'react'
import { ReportingIpcomModal } from './ReportingIpcomModal'

export const ReportingIpcom = () => {
  const [file, setFile] = useState<File | null>()

  return (
    <div className='flex flex-col sm:flex-row sm:items-center justify-between gap-[20px] sm:gap-[10px]'>
      <FileSelect
        containerClasses='w-full underline text-text min-w-[140px] mb-4 sm:mb-0'
        clearClasses=''
        onChangeCallback={(csvFile: any) => {
          setFile(csvFile)
        }}
        clearChildren={
          <>
            {file && (
              <ButtonRoundedSm
                type='button'
                loading={false}
                text='Clear selection'
                icon={<commonIcons.close />}
                iconRight
                className='absolute bg-surface-2 text-text border border-border rounded-full !py-0 !h-[18px] mt-2 sm:mt-1 left-0'
                callback={() => setFile(null)}
              />
            )}
          </>
        }
      >
        {file && (
          <div className='flex items-center justify-start text-text text-[0.9rem]'>
            <commonIcons.csvFile className=' text-[1.25rem] mr-[10px]' />
            <p>{file.name}</p>
          </div>
        )}
        {!file && (
          <div className='flex items-center justify-start text-text text-[0.9rem]'>
            <commonIcons.csvFile className=' text-[1.25rem] mr-[10px]' />
            <p>Select IPCom CSV file.</p>
          </div>
        )}
      </FileSelect>
      <div className='flex items-center justify-end gap-[10px]'>
        <ModalButton
          component={ReportingIpcomModal}
          disabled={!file}
          classes='sm:w-auto sm:grow-0'
          componentProps={{
            file
          }}
        >
          <ButtonRoundedWithIcon
            type='div'
            text='Parse File'
            icon={<commonIcons.arrowRight />}
            className='action-success'
            iconContainerClassName='bg-success text-on-success'
          />
        </ModalButton>
      </div>
    </div>
  )
}
